import type { IUploadRepository } from '../repositories/IUploadRepository.js';

export function createDeleteFileUseCase(deps: { uploadRepository: IUploadRepository }) {
  return (bucket: string, path: string): Promise<void> =>
    deps.uploadRepository.deleteFile(bucket, path);
}
